import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={8.355}
    height="6.8mm"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 2748 8455"
    {...props}
  >
    <path
      d="M2165 1552h-112c0-479-455-583-455-583v-72h-134V704c32-16 53-41 53-68s-21-51-53-67V290s-3-290-90-290-90 290-90 290v279c-32 16-52 40-52 67s20 52 52 68v193h-133v72s-456 104-456 583H583S447 1960 0 1960v95h233l405 2060h147v236h315v2396H940s166 1572-665 1572v136h2199v-136c-832 0-665-1572-665-1572h-161V4351h315v-236h147l405-2060h233v-96c-447 1-583-407-583-407zm-409 623-141 1772h-486L964 2175h792zM776 3947 428 2175h368l164 1772H776zm1196 0h-188l140-1772h396l-348 1772z"
      style={{
        fill: "#2b2a29",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
